import { Space } from "antd";
import moment from "moment";
import useProcurementStore from "store/procurement_store";

function ProcurementStageDetailsFooter(props) {

    const { current_stage_data } = useProcurementStore((state) => ({
        current_stage_data: state.current_stage_data
    }));

    const stageAssesmentCompletionMeta = {
        assessedBy: current_stage_data?.assessed_by ?? "",
        assessedAt: current_stage_data?.assessed_at ?? "",
    }

    const stageReviewedMeta = {
        reviewedBy: current_stage_data?.completed_by ?? "",
        reviewedAt: current_stage_data?.completed_at ?? "",
    }

    return (<>

        {
            ((stageAssesmentCompletionMeta?.completedAt && stageAssesmentCompletionMeta?.completedBy)
                || (stageAssesmentCompletionMeta?.assessedAt && stageAssesmentCompletionMeta?.assessedBy))
            &&
            <Space bordered direction="vertical" size="middle" style={{ width: '100%', color: "#a4a19d" }}>
                {(stageAssesmentCompletionMeta?.assessedAt && stageAssesmentCompletionMeta?.assessedBy) ?
                    (
                        <span>
                            Assessment completed - {stageAssesmentCompletionMeta?.assessedBy} - {moment(stageAssesmentCompletionMeta?.assessedAt).format("MM/DD/YY, h:mm A")}
                        </span>
                    ) : null
                }
                {(stageReviewedMeta?.reviewedAt && stageReviewedMeta?.reviewedBy) ?
                    (
                        <span>
                            Reviewed - {stageReviewedMeta?.reviewedBy} - {moment(stageReviewedMeta?.reviewedAt).format("MM/DD/YY, h:mm A")}
                        </span>
                    ) : null
                }
            </Space>
        }
    </>);
}

export default ProcurementStageDetailsFooter